import { useEffect } from 'react'
import { TrendingUp, TrendingDown, Bell, BellOff, X } from 'lucide-react'

const AUTO_DISMISS_MS = 6000

// Icono + acento por tipo de evento: cruce detectado (direction up/down,
// colores alcista/bajista) vs confirmación de toggle de vigilancia (kind
// watch-activated/watch-paused, o del interruptor maestro
// notifications-activated/notifications-paused — acento neutro en pausa,
// ninguno es una señal de mercado).
function iconAndAccent(event) {
  if (event.direction) {
    return event.direction === 'up'
      ? { Icon: TrendingUp, accent: 'var(--green-deep, #0B3D2E)' }
      : { Icon: TrendingDown, accent: '#B71C1C' }
  }
  return event.kind === 'watch-paused' || event.kind === 'notifications-paused'
    ? { Icon: BellOff, accent: 'var(--ink-soft, #4A5A52)' }
    : { Icon: Bell, accent: 'var(--gold, #B08D57)' }
}

// Toast de cruce detectado O de confirmación de toggle de vigilancia — mismo
// lenguaje visual que EmaSmaBadge (paper + hair border + Playfair Display
// para el texto principal), nada de popups nativos ni colores ad-hoc. Se
// posiciona en la esquina opuesta al badge (top-right vs top-left) para no
// solaparse; `stacked` lo baja un poco cuando el otro toast (cruce o toggle)
// ya está visible, para que no se superpongan.
export default function EmaSmaNotificationToast({ event, onDismiss, stacked = false, testId = 'ema-sma-notification-toast' }) {
  useEffect(() => {
    if (!event) return undefined
    const timer = setTimeout(onDismiss, AUTO_DISMISS_MS)
    return () => clearTimeout(timer)
  }, [event, onDismiss])

  if (!event) return null

  const { Icon, accent } = iconAndAccent(event)

  return (
    <div
      className={`absolute ${stacked ? 'top-14' : 'top-2'} right-2 z-[110] flex items-center gap-2 rounded-lg backdrop-blur-sm shadow-lg px-2.5 py-2 max-w-[260px]`}
      style={{ background: 'var(--paper, #FDFDFA)', border: '1px solid var(--hair, rgba(176,141,87,0.35))' }}
      role="status"
      data-testid={testId}
    >
      <Icon size={14} style={{ color: accent, flexShrink: 0 }} />
      <span
        className="text-[11px] font-medium leading-tight"
        style={{ color: 'var(--ink, #15211B)', fontFamily: "'Playfair Display', Georgia, serif" }}
      >
        {event.message}
      </span>
      <button
        onClick={onDismiss}
        title="Cerrar"
        className="ml-1 p-0.5 rounded hover:bg-black/5 transition-colors shrink-0"
        style={{ color: 'var(--ink-soft, #4A5A52)' }}
      >
        <X size={12} />
      </button>
    </div>
  )
}
